
import { memo } from "react";
import { IIconsProps } from "./icons.model";

const GestaoReceberIcon = (props: IIconsProps) => {
    return (
        <i id={props.id} className='fa-solid fa-sack-dollar' style={{ fontSize: props.fontSize, color: props.color }} />
    );
};

export default memo(GestaoReceberIcon);

